export default class GError {
  constructor({ message, code }) {
    this.message = message;
    this.code = code;
  }

  static checkError(apiResult) {
    let hasError = false;
    if (apiResult.error) {
      hasError = true;
      if (apiResult.error.message) {
        return { message: apiResult.error.message, code: apiResult.error.code };
      } else if (typeof apiResult.error === "string") {
        return apiResult.error;
      }
    } else if (apiResult.scalar) {
      hasError = true;
      if (typeof apiResult.scalar === "string") {
        return apiResult.scalar;
      }
    } else if (apiResult.insert === false) {
      hasError = true;
      if (apiResult.message) {
        return apiResult.message;
      }
    }
    return hasError;
  }
}
